/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Main account or subaccount visible to current user.
 */
export interface UserAccountDto {
  /**
   * Value for accountId request parameter.
   */
  id: number;
  name: string;
  status?: UserAccountDto.StatusEnum;
  /**
   * True for main account.
   */
  main: boolean;
  /**
   * Subaccount type, null for main account. No trading on STRATEGY.
   */
  subAccountType?: UserAccountDto.SubAccountTypeEnum;
}
export namespace UserAccountDto {
  export const StatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    Paused: 'PAUSED',
  } as const;
  export type StatusEnum = (typeof StatusEnum)[keyof typeof StatusEnum];
  export const SubAccountTypeEnum = {
    Trading: 'TRADING',
    Strategy: 'STRATEGY',
  } as const;
  export type SubAccountTypeEnum =
    (typeof SubAccountTypeEnum)[keyof typeof SubAccountTypeEnum];
}
